import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of, startWith, withLatestFrom} from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import * as PaperChatActions from './paper-chat.actions';
import {PaperChatWebSocketService} from './paper-chat.service';
import {Store} from '@ngrx/store';
import {selectFilterType, selectSelectedQueryParam} from './paper-chat.selector';

@Injectable()
export class PaperChatEffects {
  private readonly store: Store = inject(Store);
  private readonly wsService: PaperChatWebSocketService = inject(PaperChatWebSocketService);
  private readonly actions$: Actions = inject(Actions);

  // Handle connection to the project
  connectToProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaperChatActions.connectToProject),
      withLatestFrom(
        this.store.select(selectSelectedQueryParam()),
        this.store.select(selectFilterType())
      ),
      mergeMap(([{projectId, summaryId, paperId}, queryPaperId, filterType]) =>
        this.wsService.connect(projectId, filterType, paperId ? "" + paperId : queryPaperId, summaryId).pipe(
          map((message) => PaperChatActions.receiveMessage({message})),
          startWith(PaperChatActions.connectSuccess({projectId})),
          catchError((error) =>
            of(PaperChatActions.connectFailure({projectId, error}))
          )
        )
      )
    )
  );

  // Handle disconnection from the project
  disconnectFromProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaperChatActions.disconnect),
      tap(({projectId}) => this.wsService.disconnect()),
      map(({projectId}) => PaperChatActions.disconnectSuccess({projectId})),
      catchError(({projectId, error}) =>
        of(PaperChatActions.disconnectFailure({projectId, error}))
      )
    )
  );
  /*
    setChatFilterType$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PaperChatActions.setChatFilterType),
        tap(({projectId}) => this.wsService.disconnect()),
        map(({projectId}) => PaperChatActions.connectToProject({projectId: projectId}))
      ));
  */
  // Handle sending messages to the project
  sendMessageToProject$ = createEffect(() =>
      this.actions$.pipe(
        ofType(PaperChatActions.sendMessage),
        tap(({projectId, message}) => this.wsService.sendMessage(message)),
        map(({projectId}) => ({type: '[WebSocket] Message Sent', projectId})), // Optional success action placeholder
        catchError(({projectId, error}) =>
          of(PaperChatActions.connectFailure({projectId, error}))
        )
      ),
    {dispatch: false} // No further state update required for sending a message
  );
}
